module.exports = __webpack_public_path__ + "static/img/icon_zj_04.01c6059c.png";